import { apiClient } from './client';

export interface ApiKeyScope {
  scope: string;
  description: string;
}

export interface ApiKeyItem {
  id: number;
  name: string;
  prefix: string;
  scopes: string[];
  expireson: string | null;
  lastusedon: string | null;
  revokedon: string | null;
  status: 'ACTIVE' | 'EXPIRED' | 'REVOKED';
  createdon: string;
  createdby: { id: number; name: string; email: string };
}

export interface CreatedApiKey {
  id: number;
  name: string;
  prefix: string;
  scopes: string[];
  expireson: string | null;
  createdon: string;
  /** The full key -- returned exactly once, at creation. */
  key: string;
}

export interface CreateApiKeyInput {
  name: string;
  scopes: string[];
  /** ISO 8601 date-time. Omit for a key that never expires. */
  expiresOn?: string;
}

export class ApiKeysAPI {
  static async scopes() {
    return apiClient.get<ApiKeyScope[]>('/api-keys/scopes');
  }

  static async list() {
    return apiClient.get<ApiKeyItem[]>('/api-keys');
  }

  static async create(input: CreateApiKeyInput) {
    return apiClient.post<CreatedApiKey>('/api-keys', input);
  }

  static async revoke(id: number) {
    return apiClient.delete<{ id: number; revoked: boolean }>(`/api-keys/${id}`);
  }
}
